<template>
	<div class="bidding-system" v-if="isLayoutReady">
		<!-- 头部导航栏 -->
		<Header class="headerBox"></Header>

		<!-- 导航栏 -->
		<div class="left-navigation" :class="isCollapse ? '' : 'left-navigation-isCollapse'">
			<el-menu :default-active="defaultActive" class="el-menu-vertical-demo" @open="handleOpen">
				<div class="el-menu-vertical-demo-item" v-for="(item, index) in tabList" :key="item.id">
					<treeNode :navIndex="index" :item="item" @menuItemClick="handleMenuClick" @xialkuang="xialkuang">
					</treeNode>
				</div>
			</el-menu>
		</div>
		<div v-if="currentView != ''" class="right-page" :class="isCollapse ? '' : 'right-page-isCollapse'">
			<component :is="currentView" :GtsData="GtsData" :locationData="locationData" :userItem="userItem"
				:key="datekey"></component>
			<div class="beian" @click="skipClick">@Copyright 健康监护平台 | 苏ICP备2022040978号-1</div>
		</div>
		<div v-else>
			<div class="beijing-img">
				<div class="beijing-beian" @click="skipClick">@Copyright 健康监护平台 | 苏ICP备2022040978号-1</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		setSystemUserTree,
		deviceUserDevice
	} from '@/assets/api/api.js'
	import {
		menuLoadPrivileges,
		deviceFindUser
	} from '@/assets/api/user.js'
	import componentRegistry from './config/componentRegistry.js'
	import menuConfig from './config/menuConfig.js'

	export default {
		components: {
			...componentRegistry
		},
		data() {
			return {
				GtsData: {},
				tabList: JSON.parse(JSON.stringify(menuConfig)),
				currentView: '',
				isCollapse: true,
				locationData: {},
				defaultActive: '',
				listData: [],
				isLayoutReady: false,
				datekey: Date.now(),
				userItem: {}
			}
		},
		created() {
			this.menuLoadPrivileges()
		},
		methods: {
			skipClick() {
				window.open('https://beian.miit.gov.cn');
			},

			getCurrentUserId() {
				try {
					const user = localStorage.getItem('user')
					if (!user) return ''
					const parsed = JSON.parse(user)
					return parsed ? parsed.id : ''
				} catch (e) {
					return ''
				}
			},

			menuLoadPrivileges() {
				const userId = this.getCurrentUserId()
				if (!userId) {
					this.$message.error('登录信息已失效，请重新登录')
					this.$router.push({ path: `/login` })
					return
				}
				const params = { userId }

				menuLoadPrivileges(params).then((res) => {
					this.listData = res.data.data
					if (this.listData.length) {

						for (let item of this.listData) {
							if (item.name == '监控平台') {
								this.setSystemUserTree()
							}
						}

						for (let item of this.tabList) {
							for (let value of this.listData) {
								if (item.name == value.name) {
									item.status = true
								}
								if (value.name != '监控平台') {
									for (let item2 of item.children) {
										for (let value2 of value.children) {
											if (item2.sonName == value2.name) {
												item2.status = true
											}
										}
									}
								}
							}
						}

						for (let i = this.tabList.length - 1; i >= 0; i--) {
							for (let sln = this.tabList[i].children.length - 1; sln >= 0; sln--) {
								if (!this.tabList[i].children[sln].status) {
									this.tabList[i].children.splice(sln, 1)
								}
							}
							if (!this.tabList[i].status) {
								this.tabList.splice(i, 1)
							}
						}
						for (let i = this.tabList.length - 1; i >= 0; i--) {
							if (!this.tabList[i].children.length && this.tabList[i].name != '监控平台') {
								this.tabList.splice(i, 1)
							}
						}

						this.isLayoutReady = true
					} else {
						this.$message.error('您暂无权限！');
						this.$router.push({
							path: `/login`
						})
					}
				}).catch((err) => {
					console.error('加载菜单权限失败', err)
				})
			},
			deviceUserDevice(item) {
				item.zhuangtai = true
				let params = {
					userId: item.id,
				}
				deviceUserDevice(params).then((res) => {
										if (item.children) {
						item.children = [...item.children, ...res.data.data]
					} else {
						item.children = res.data.data
					}
				}).catch((err) => {
					console.error('请求失败', err);
				})
			},
			setSystemUserTree() {
				const userId = this.getCurrentUserId()
				if (!userId) {
					this.$message.error('登录信息已失效，请重新登录')
					this.$router.push({ path: `/login` })
					return
				}
				let params = { userId }
				setSystemUserTree(params).then((res) => {
										const arr = res.data.data
					this.walkTree(arr)
					for (let item of this.tabList) {
						if (item.name == '监控平台') {
							item.children = arr
						}
					}

					if (this.$route.query.imei) {
						this.handleMenuClick(arr[0])
					}
				}).catch((err) => {
					console.error('请求失败', err);
				})
			},
			walkTree(arr) {
				if (!Array.isArray(arr)) {
					return
				}
				arr.forEach(element => {
					if (element.deviceId) {
						return
					}
					if (Array.isArray(element.children) && element.children.length) {
						this.walkTree(element.children)
					}
				})
			},
			handleMenuClick(item) {
								this.userItem = item
				this.locationData = {}
				if (item.deviceId || item.id) {
										this.currentView = 'CampusAnnouncement'
					if (item.deviceId) {
						this.locationData = item
											} else if (item.id) {
						if (!item.zhuangtai) {
							this.deviceUserDevice(item)
						}
						this.loadGroupLocation(item)
											}
				} else if (item.component) {
					this.currentView = item.component
					this.datekey = Date.now()
									} else if (item.routerUrl) {
					this.$router.push({
						path: item.routerUrl
					})
				}
							},
			loadGroupLocation(item) {
				const params = {
					userId: item.id
				}
				deviceFindUser(params).then((res) => {
					this.GtsData = res.data
									}).catch((err) => {
					console.error('获取群体位置失败', err)
				})
			},
			xialkuang(item) {
				item.xialkuang = true
			},
			handleOpen(key, keyPath) {
							},
			handleClose(key, keyPath) {
							}
		}
	}
</script>

<style lang='scss' scoped>
	:deep() {
		.el-menu-vertical-demo-item:nth-child(1)>.el-sub-menu {
			li {
				max-height: 400px !important;
				overflow: hidden auto !important;
			}
		}
	}

	.bidding-system {
		width: 100%;
		height: 100vh;
		background-color: #fff;
		position: relative;

		.headerBox {
			height: 70px;
			z-index: 15;
		}

		.left-navigation {
			height: calc(100vh - 80px);
			overflow: auto;

			:deep() {
				.el-menu-item.is-active {
					color: #fff;
					font-size: 14px !important;
					background-color: #459FFC,
				}

				.el-menu {
					width: 240px;
					border: 0px;
				}

				.tupian {
					position: absolute;
					left: 25px;
					width: 15px;
					height: 15px;
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}

				.navigation-center {
					position: absolute;
					left: 55px;
					font-size: 16px;
				}

				.el-sub-menu .el-sub-menu__icon-arrow {
					right: 40px;
				}

				.el-sub-menu {
					font-size: 16px;
				}

				.el-menu .el-menu--inline {
					font-weight: 400;
				}

				.el-sub-menu__title span {
					font-weight: 700 !important;
					font-size: 16px;
				}
			}
		}

		.left-navigation-isCollapse {
			width: 50px;

			:deep() {
				.el-menu {
					width: 50px;
					border: 0px;
				}
			}
		}

		.right-page {
			position: absolute;
			left: 240px;
			top: 69px;
			padding: 30px 30px;
			padding-bottom: 0px;
			width: calc(100% - 240px);
			height: calc(100vh - 70px);
			background-color: #F4F7FC;
		}

		.right-page-isCollapse {
			left: 50px;
			width: calc(100% - 50px);
		}

		.beijing-img {
			position: absolute;
			left: 240px;
			top: 70px;
			padding-bottom: 0px;
			width: calc(100% - 240px);
			height: calc(100vh - 70px);
			background-image: url(./images/beijing.jpg);
			background-repeat: no-repeat;
			background-color: #F4F7FC;
			background-size: 96% 94%;
			background-position: center center;
		}

		.beijing-beian {
			color: #2C9DF7;
			font-size: 15px;
			position: absolute;
			left: 50%;
			bottom: 10px;
			transform: translate(-50%,0px);
		}

		.beian {
			margin-left: 550px;
			color: #2C9DF7;
			font-size: 14px;
			margin-top: 5px;
		}
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 240px;
	}
</style>
